export default __webpack_public_path__ + "static/media/gold@2x.c5d63669.png";